angular.module('zc.projects')

.directive 'campaignFilterView', ($filter, $location, $q, $state, $timeout, $translate, Meta, CampaignSegment, SearchFilter, lib) ->
  return {
    restrict: 'E'
    require: '?filters'
    scope:
      filters: '='
      project: '='
      hideDevice: '='
      hideCampaignSegmentId: '='
      hideSearchTerm: '='
      hideReset: '='
      showHiddenAbTestToggle: '='
      update: '&'
      reset: '&'
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_filter.html'

    link: (scope, element, attrs) ->
      scope.devices = [ { label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noDeviceSetting'), name: null} ]
      scope.campaign_segments = [ { label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noSegmentSetting'), id: null} ]
      # below is required for tests...
      scope.selected = {
        device: scope.devices[0]
        campaign_segment: scope.campaign_segments[0]
      }

      # when switching to new project by search box, if new project.enable_app is false
      # need reset filters.device and filters.device_value if `app` device was selected.
      if scope.filters.device_value?.name == 'app' && !scope.project.enable_app
        scope.filters.device_value = scope.devices[0]
        scope.filters.device = scope.devices[0].name

      activate = () ->
        promises = []
        unless scope.hideDevice
          promises.push Meta.getDevices().then (devices) ->
            devices = devices.filter (device) -> device.name in ['pc', 'sp'] || (device.name == 'app' && scope.project.enable_app)
            scope.devices = [ { label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noDeviceSetting'), name: null} ].concat devices

        unless scope.hideCampaignSegmentId
          promises.push CampaignSegment.all(scope.project.id).then (campaign_segments) ->
            campaign_segments = for segment in campaign_segments when segment.segment_type isnt 'custom_old'
              label: segment.name
              id: segment.id
            campaign_segments = campaign_segments.reverse()
            scope.campaign_segments = [ { label: $translate.instant('projectsCampaigns.directives.campaignFilterView.noSegmentSetting'), id: null} ].concat campaign_segments

        # NOTE:
        # When device and segment are both hidden, the promise are resolved too early
        # and causes a UI bug such as that default dates are not set in the first view.
        # To avoid the bug, let's set $timeout to do nothing... ;(
        unless promises.length
          timeout = $timeout (->), 0
          promises.push timeout

        $q.all(promises).then (res) ->
          SearchFilter.setComponentDefaults('campaignFilter', {
            device:
              default: null
              keyProperty: 'name'
              getter: (name) ->
                _.find(scope.devices, (d) -> d.name == name)
            campaign_segment:
              default: undefined
              keyProperty: 'id'
              getter: (id) ->
                _.find(scope.campaign_segments, (d) -> d.id == parseInt(id))
          })

          scope.selected.start_at = scope.filters.start_at
          scope.selected.end_at = scope.filters.end_at

          if scope.filters.device_value
            scope.selected.device = _.find(scope.devices, (d) -> d.name == scope.filters.device_value.name)
          else
            scope.selected.device = scope.devices[0]

          if scope.filters.campaign_segment_value
            scope.selected.campaign_segment = _.find(scope.campaign_segments, (d) -> d.id == scope.filters.campaign_segment_value.id)
            unless scope.selected.campaign_segment
              scope.selected.campaign_segment = scope.campaign_segments[0]

          else
            scope.selected.campaign_segment = scope.campaign_segments[0]

          scope.updateData()

      scope.segmentNameFor = (id) ->
        return scope.campaign_segments[0].label if !id
        segment = _.find(scope.campaign_segments, {id: id})
        return segment.label

      scope.updateData = () ->
        scope.filters.start_at = scope.selected.start_at
        scope.filters.end_at = scope.selected.end_at

        unless scope.hideDevice
          if scope.selected.device
            scope.filters.device = scope.selected.device.name
            scope.filters.device_value = scope.selected.device
          else
            scope.filters.device = scope.devices[0].name
            scope.filters.device_value = scope.devices[0]

        unless scope.hideCampaignSegmentId
          scope.filters.campaign_segment = scope.selected.campaign_segment.id
          scope.filters.campaign_segment_value = scope.selected.campaign_segment

        unless scope.hideSearchTerm
          scope.filters.search_term = scope.selected.search_term

        # html campaignFilter form might not yet exists (in tests)
        if scope.campaignFilter
          scope.campaignFilter.$setPristine()

        SearchFilter.set(scope.filters)
        SearchFilter.updateComponentDefaults('campaignFilter')

        scope.update()

      # Reset the date filter input field values. Some background to this implementation:
      # - the input fields have min and max values:
      #   - start_at's max value is end_at's value
      #   - end_at's min value is start_at's value
      # - The min/max value change as the end_at / start_at value change, but this is not instant.
      #   Therefore, when resetting the values, the limiting ones needs to be changed first.
      #   For example:
      #      - if start_at's max value (end_at) is set BEFORE the DEFAULT start_at value (ie. beginning of the month),
      #      the end_at's value must be reset first so that the start_at can be set to the DEFAULT value. And since
      #      the changes aren't instant some time must be given using $timeout.
      resetDateFilterFields = ->
        if moment(scope.selected.end_at).isBefore(SearchFilter.pageDefaults.start_at)
          scope.selected.end_at = SearchFilter.pageDefaults.end_at
          $timeout ->
            scope.selected.start_at = SearchFilter.pageDefaults.start_at
          , 0
        else
          scope.selected.start_at = SearchFilter.pageDefaults.start_at
          $timeout ->
            scope.selected.end_at = SearchFilter.pageDefaults.end_at
          , 0

      scope.resetFilters = ->
        scope.filters.start_at = SearchFilter.pageDefaults.start_at
        scope.filters.end_at = SearchFilter.pageDefaults.end_at
        scope.filters.device = scope.devices[0].name
        scope.filters.device_value = scope.devices[0]
        scope.filters.campaign_segment = scope.campaign_segments[0].id
        scope.filters.campaign_segment_value = scope.campaign_segments[0]
        scope.filters.search_term = ''
        if scope.showHiddenAbTestToggle
          scope.filters.include_hidden_ab_test = false

        resetDateFilterFields()

        scope.selected.device = scope.devices[0]
        scope.selected.campaign_segment = scope.campaign_segments[0]
        scope.selected.search_term = ''

        # Merge with page specific defaults, which can be set in corresponding
        # page's controller
        scope.filters = SearchFilter.reset(scope.filters)
        SearchFilter.resetComponentDefaults('campaignFilter')

        # html campaignFilter form might not yet exists (in tests)
        if scope.campaignFilter
          scope.campaignFilter.$setPristine()

        # these will be broadcasted from parent controller
        scope.reset()
        scope.update()

      activate()
  }



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_filter_view.js.coffee